export default "__VITE_ASSET__Bt46eKsk__"